import React, { useEffect, useState } from 'react'
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import UserList from './UserList.js'
import Chat from './Chat.js'

export default function Conversations() {

    const [selectedCase, setSelectedCase] = useState('')
    const [expanded, setExpanded] = useState('')

    return (
        <>
            <div className="flex h-full flex-row w-full">
                <UserList _handleExpanded={(e) => {setExpanded(e)}}_handleSelected={(e) => { setSelectedCase(e) }} />
                {selectedCase != '' ? <Chat selected={selectedCase} expanded={expanded} /> : null}
            </div>
        </>
    );
};